import { render, staticRenderFns } from "./ArticlesCounter.vue?vue&type=template&id=bca50cd0&scoped=true"
import script from "./ArticlesCounter.vue?vue&type=script&lang=ts"
export * from "./ArticlesCounter.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesCounter.vue?vue&type=style&index=0&id=bca50cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca50cd0",
  null
  
)

export default component.exports